import en from 'vee-validate/dist/locale/en.json';

export default {
  validate: (value, { other }) => {
    if (Array.isArray(other) && ![undefined, null].includes(value)) {
      return !other.map(s => s.toString()).includes(value.toString());
    }

    return {
      valid: value !== other,
      required: true,
    };
  },
  params: ['other'],
  message: `${en.messages.is_not}.`,
  computesRequired: true,
};
